module.exports = __webpack_public_path__ + "static/media/011-rhombus-purple.fd15e677.svg";